module.exports = __webpack_public_path__ + "static/media/calendar-clock-outline.55666038.svg";